import { render } from "./CreateTaskModal.vue?vue&type=template&id=621a5af1&ts=true"
import script from "./CreateTaskModal.vue?vue&type=script&lang=ts"
export * from "./CreateTaskModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__